import React, { useState } from 'react';

const Activities = () => {
  const [isOpen, setIsOpen] = useState(false);
  const activities = [
    { name: 'Scuba Diving', href: '#' },
    { name: 'Kayaking', href: '#' },
    { name: 'Rafting', href: '#' },
    { name: 'Paragliding', href: '#' },
    { name: 'Rock Climbing', href: '#' },
    { name: 'Trekking', href: '#' },
  ];

  return (
    <div className="border-b border-gray-800 md:border-none">
      <button 
        className="flex justify-between items-center w-full text-white font-bold mb-4 md:mb-4 md:cursor-default"
        onClick={() => setIsOpen(!isOpen)}
      >
        <h3>Activities</h3>
        <svg
          className={`w-5 h-5 md:hidden transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <ul className={`space-y-2 ${isOpen ? 'block' : 'hidden'} md:block`}>
        {activities.map((activity, index) => (
          <li key={index}>
            <a href={activity.href} className="hover:text-white transition">
              {activity.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Activities;